export const ALERT_KIND = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

type KindConst = keyof typeof ALERT_KIND;
export type AlertKind = typeof ALERT_KIND[KindConst];
